import React, {PropTypes} from 'react';
import {
  injectIntl,
  IntlProvider,
  FormattedRelative,
} from 'react-intl';

export default injectIntl(({intl}) => {
  document.title = intl.formatMessage({id: "title"});
  return null;
});
